import React from "react";
export default function ReadyToTakeControl() {
  const openAppStore = () => {
    window.open("https://apps.apple.com/us/app/barndesk/id6768716555", "_blank", "noopener,noreferrer");
  };
  const openGooglePlay = () => {
    window.open("https://play.google.com/store/apps/details?id=com.barndesk.app", "_blank", "noopener,noreferrer");
  };
  return <section data-section-id="241175" id="finalcalltoaction" className="relative overflow-hidden bg-background py-32 sm:py-48">
      {/* Top decorative triangle */}
      <svg className="absolute top-0 left-0 w-full h-16 md:h-32 text-muted/40 fill-current z-10 pointer-events-none" preserveAspectRatio="none" viewBox="0 0 100 100" aria-hidden="true">
        <polygon points="0,0 100,0 100,100 0,0" />
      </svg>
      {/* Soft radial glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[600px] h-[600px] sm:w-[1000px] sm:h-[1000px] bg-[radial-gradient(circle,var(--color-primary)_0%,transparent_60%)] opacity-10 dark:opacity-20 blur-3xl animate-pulse rounded-lg"></div>
      </div>
      <div className="relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="font-default text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-[1.1] text-primary mb-6 max-w-3xl drop-shadow-sm">
          Ready for more pasture time?
        </h2>
        <p className="font-default text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-12">
          Free for up to 10 animals. No credit card to start.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <button type="button" onClick={openAppStore} className="inline-flex items-center gap-3 h-14 px-6 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity">
            <span className="flex flex-col items-start leading-tight">
              <span className="text-[11px] uppercase tracking-wide opacity-80">Download on the</span>
              <span className="text-lg font-semibold">App Store</span>
            </span>
          </button>
          <button type="button" onClick={openGooglePlay} className="inline-flex items-center gap-3 h-14 px-6 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity">
            <span className="flex flex-col items-start leading-tight">
              <span className="text-[11px] uppercase tracking-wide opacity-80">Get it on</span>
              <span className="text-lg font-semibold">Google Play</span>
            </span>
          </button>
        </div>
        <p className="mt-10 font-serif italic text-chart-2 text-lg">
          Built by a Farmer, for Farmers.
        </p>
      </div>
      {/* Bottom decorative triangle */}
      <svg className="absolute bottom-0 left-0 w-full h-16 md:h-32 text-muted/40 fill-current z-10 pointer-events-none" preserveAspectRatio="none" viewBox="0 0 100 100" aria-hidden="true">
        <polygon points="0,100 100,100 100,0 0,100" />
      </svg>
    </section>;
}